import { Controller } from "@hotwired/stimulus"

// Light/dark switch. With no choice made the site follows the device setting
// (daisyUI's prefersdark theme); a click pins one by setting data-theme on
// <html> and remembering it in a cookie, which the layouts read to render the
// next page the same way. See ApplicationHelper#chosen_theme.
const THEMES = { light: "trove", dark: "trove-dark" }
const deviceDark = window.matchMedia("(prefers-color-scheme: dark)")

export default class extends Controller {
  connect() {
    this.sync = () => this.reflect()
    deviceDark.addEventListener("change", this.sync)
    this.reflect()
  }

  disconnect() {
    deviceDark.removeEventListener("change", this.sync)
  }

  toggle() {
    const next = this.dark ? "light" : "dark"

    document.documentElement.dataset.theme = THEMES[next]
    document.cookie = `theme=${next}; path=/; max-age=31536000; SameSite=Lax`
    this.reflect()
  }

  get dark() {
    const theme = document.documentElement.dataset.theme
    return theme ? theme === THEMES.dark : deviceDark.matches
  }

  // The server can't know the device setting, so the first render may have
  // guessed light; correct the button once we're in the browser.
  reflect() {
    this.element.setAttribute("aria-pressed", String(this.dark))
  }
}
